/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { nonNull } from '../utils/util';

export type inputState = 'NORMAL' | 'UNKNOWN' | 'ENTERED';

export type UnknownInputValue = {
  readonly inputState: InputState.UNKNOWN;
};

export type NormalInputValue = {
  readonly inputState: InputState.NORMAL;
};

export type NormalOrUnknownInputValue = UnknownInputValue | NormalInputValue;

export enum InputState {
  NORMAL = 'NORMAL',
  UNKNOWN = 'UNKNOWN',
  ENTERED = 'ENTERED',
}

export interface InputStateNormalConfig {
  readonly inputState: {
    readonly normal: string;
  };
}

export interface InputStateConfig {
  readonly inputState: {
    readonly normal: string;
    readonly unknown: string;
  };
}

export interface OptionalInputStateConfig {
  readonly inputState?: Partial<InputStateConfig['inputState']>;
}

export type KeyLabelConfigOption = {
  readonly key: string;
  readonly label: string;
};

/* helper functions */

export function isNormalOrUnknown<T extends { readonly inputState?: string }>(value: T | null | undefined) {
  return value?.inputState === InputState.NORMAL || value?.inputState === InputState.UNKNOWN;
}

export function filterInputStateEntered<T extends { readonly inputState?: string }>(
  value: T | null | undefined,
  hasInputState = true
) {
  if (!hasInputState) {
    return nonNull(value)
      ? (value as T & {
          inputState: InputState.ENTERED;
        })
      : null;
  }

  return nonNull(value) && value.inputState === InputState.ENTERED
    ? (value as T & {
        inputState: InputState.ENTERED;
      })
    : null;
}

export function hasInputState<T extends OptionalInputStateConfig>(elementConfig: T) {
  return {
    has: nonNull(elementConfig.inputState),
    hasUnknown: nonNull(elementConfig.inputState?.unknown),
    hasNormal: nonNull(elementConfig.inputState?.normal),
  };
}

export const NORMAL_VALUE_KEY = 'NORMAL';
